export const FrequencyLabels: Record<string, string> = {
  DAILY: "Quotidien",
  WEEKLY: "Hebdomadaire",
  BIWEEKLY: "Toutes les 2 semaines",
  MONTHLY: "Mensuel",
  QUARTERLY: "Trimestriel",
  ANNUALLY: "Annuel",
};

export const WeekdayLabels: Record<string, string> = {
  MONDAY: "Lun",
  TUESDAY: "Mar",
  WEDNESDAY: "Mer",
  THURSDAY: "Jeu",
  FRIDAY: "Ven",
  SATURDAY: "Sam",
  SUNDAY: "Dim",
};

export const OrdinalLabels: Record<string, string> = {
  FIRST: "1er",
  SECOND: "2e",
  THIRD: "3e",
  FOURTH: "4e",
  LAST: "Dernier",
  ALL: "Tous",
};

export const formatPlanSummary = (cp: any) => {
  if (!cp) return "—";
  const freq = FrequencyLabels[cp.frequency] ?? cp.frequency ?? "—";
  const timeStr = cp.timeOfDay ? ` • ${cp.timeOfDay}` : "";
  const period =
    (cp.startDate
      ? ` • du ${new Date(cp.startDate).toLocaleDateString("fr-FR")}`
      : "") +
    (cp.endDate
      ? ` au ${new Date(cp.endDate).toLocaleDateString("fr-FR")}`
      : "");

  if (["DAILY", "WEEKLY", "BIWEEKLY"].includes(cp.frequency)) {
    const days =
      (cp.weekdays || [])
        .map((w: string) => WeekdayLabels[w] ?? w)
        .join(" · ") || "—";
    const offset =
      cp.frequency === "BIWEEKLY" &&
      (cp.weekOffset === 0 || cp.weekOffset === 1)
        ? ` (quinzaine: ${cp.weekOffset === 0 ? "paire" : "impaire"})`
        : "";
    return `${freq} • ${days}${offset}${timeStr}${period}`;
  }

  // MONTHLY/QUARTERLY/ANNUALLY
  const ord = OrdinalLabels[cp.ordinal] ?? cp.ordinal ?? "—";
  const wd =
    cp.ordinal !== "ALL"
      ? ` ${WeekdayLabels[cp.monthlyWeekday] ?? cp.monthlyWeekday ?? ""}`
      : "";
  const anchor =
    (cp.frequency === "QUARTERLY" || cp.frequency === "ANNUALLY") &&
    cp.anchorMonth
      ? ` • départ: ${cp.anchorMonth}/${new Date().getFullYear()}`
      : "";
  return `${freq} • ${ord}${wd}${anchor}${timeStr}${period}`;
};
